import axios from 'axios';
const getAllTemplateSchedulers = ({ showActive, showMine }) =>
  axios.post(`/template_schedulers/get_all_template_schedulers`, {
    show_active: showActive,
    show_mine: showMine,
  });
const getTemplateSchedulersForCompany = ({ companyId, showActive, showMine }) =>
  axios.post(`/template_schedulers/get_template_schedulers_for_company`, {
    company_id: companyId,
    show_active: showActive,
    show_mine: showMine,
  });
const updateTemplateScheduler = scheduler =>
  axios.post(`/template_schedulers/update_template_scheduler`, scheduler);
const deleteTemplateScheduler = id =>
  axios.get(`/template_schedulers/delete_template_scheduler?id=${id}`);

export default {
  getAllTemplateSchedulers,
  updateTemplateScheduler,
  deleteTemplateScheduler,
  getTemplateSchedulersForCompany,
};
